import styled from "@emotion/styled";
import { TextField } from "@mui/material";

export default styled(TextField)({
    "& label.Mui-focused": {
        color: "#586A84",
        fontSize: 17,
        top: "1px",
        marginInlineStart: "-1px",
    },
    "& label": {
        color: "#586A84",
        fontSize: 14,
        top: "-6px",
    },
    "& label.MuiFormLabel-filled.MuiInputLabel-shrink": {
        color: "#586A84",
        fontSize: 17,
        top: "1px",
        marginInlineStart: "-1px",
    },
    "& .MuiInput-underline:after": {
        borderBottomColor: "#405289",
        borderRadius: "6px",
    },
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            borderColor: "#BEC3C9",
            borderRadius: "6px",
        },
        "&:hover fieldset": {
            borderColor: "#405289",
            borderRadius: "6px",
        },
        "&.Mui-focused fieldset": {
            borderColor: "#405289",
            borderRadius: "6px",
        },
    },
});
